import { headFromArray, isValueExist } from '@util';
import { ImageService } from '@/services';

import { Observable } from 'rxjs';

function submitMedia(fileField, file, campaignId) {
    let formData = new FormData();
    formData.append(fileField, file);

    return axios
        .post(
            `/uploads/media${campaignId ? '?campaignId=' + campaignId : ''}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        )
        .then((res) => {
            return res.data;
        });
}

//@type media || video
function submit$(
    type = 'media',
    fileField,
    file,
    campaignId,
    isPublic,
    isMyCategory,
    isTemplate
) {
    return new Observable(async (obs) => {
        file = headFromArray(file);
        let canceled = false;

        let formData = new FormData();
        formData.append(fileField, file);

        try {
            obs.next({ type: 'progress', data: 'progress' });

            const { data } = await ImageService.uploadMyFile({
                type,
                formData,
                params: {
                    campaignId: campaignId ? campaignId : undefined,
                    isPublic: isPublic ? '1' : undefined,
                    isMyCategory: isMyCategory ? '1' : undefined,
                },
            });
            if (!isValueExist(data)) {
                obs.error('error');
                return;
            }
            if (canceled) return;
            if (!isTemplate) {
                data[0].size = file.size;
                obs.next({ type: 'load', data });
                obs.complete();
                return;
            }

            const { path, meta } = headFromArray(data);
            const { data: generatedData } = await ImageService.generateMedia({
                data: {
                    media: path,
                    meta,
                },
                campaignId,
            });

            if (!isValueExist(generatedData)) {
                obs.error('error');
                return;
            }

            if (canceled) return;

            obs.next({ type: 'load', data: headFromArray(generatedData) });
            obs.complete();
        } catch (err) {
            obs.error(err);
        }
        return () => {
            canceled = true;
        };
    });
}

//@type media || video
function externalMediaSubmit$(
    type = 'media',
    fileField,
    file,
    campaignId,
    isPublic,
    isMyCategory,
    isTemplate
) {
    return new Observable(async (obs) => {
        file = headFromArray(file);
        let canceled = false;

        let formData = new FormData();
        formData.append(fileField, file);

        try {
            obs.next({ type: 'progress', data: 'progress' });

            const response = await ImageService.uploadExternalFile({
                type,
                formData,
                params: {
                    campaignId: campaignId ? campaignId : undefined,
                    isPublic: isPublic ? '1' : undefined,
                    isMyCategory: isMyCategory ? '1' : undefined,
                },
            });

            const { data } = response;

            if (!isValueExist(data)) {
                obs.error('error');
                return;
            }
            if (canceled) return;
            if (!isTemplate) {
                data[0].size = file.size;
                obs.next({ type: 'load', data });
                obs.complete();
                return;
            }

            const { path, meta } = headFromArray(data);
            const { data: generatedData } = await ImageService.generateMedia({
                data: {
                    media: path,
                    meta,
                },
                campaignId,
            });

            if (!isValueExist(generatedData)) {
                obs.error('error');
                return;
            }

            if (canceled) return;

            obs.next({ type: 'load', data: headFromArray(generatedData) });
            obs.complete();
        } catch (err) {
            obs.error(err);
        }
        return () => {
            canceled = true;
        };
    });
}

function submitVideo(fileField, file, campaignId) {
    let formData = new FormData();
    formData.append(fileField, file);

    return axios
        .post(
            `/uploads/video${campaignId ? '?campaignId=' + campaignId : ''}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        )
        .then((res) => {
            return res.data;
        });
}

function submitFile(fileField, file) {
    let formData = new FormData();
    formData.append(fileField, file);

    return axios
        .post('/uploads/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            return res.data;
        });
}

function submitAssetMedia(fileField, file) {
    let formData = new FormData();
    formData.append(fileField, file);

    return axios
        .post('/uploads/asset/media', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            return res.data;
        });
}

export default {
    submitMedia,
    submit$,
    externalMediaSubmit$,
    submitVideo,
    submitFile,
    submitAssetMedia,
};
